module.exports = __webpack_public_path__ + "static/media/BERJALEMPA_MENU-normal.4cc1e0b7.png";